export default {
  methods: {
    track (args) {
      var data = {...args}
      if(typeof window.lastTracked !== 'undefined') { // For app to avoid double trigger of ionViewDidEnter
        if(JSON.stringify(window.lastTracked) === JSON.stringify(data)) {
          // console.log('duplicate track rejected' , data, window.lastTracked)
          return false
        }
        //   console.log(' not matched = ', JSON.stringify(window.lastTracked), JSON.stringify(data))    
        window.lastTracked = Object.assign({}, data)
        setTimeout(() => window.lastTracked = null, 1000);
      }
      if(!data['event']) {
        data['event'] = {}
      }
      data['event']['ep.platform'] = this.$platform
      // console.log(' track = ', JSON.stringify(window.lastTracked), JSON.stringify(data))
      if (typeof this.$track === 'function') {
        var trackData = { ...data, debug: this.$ga4Debug || process.env.GA4_DEBUG }
        // console.log( '$track defined ', trackData)
        this.$track(trackData)
      }
    },
    trackBeginCheckout () {
      var items = this.$store.getters.cart.map(item => {
        return {
          'id': item.id,
          'name': item.name,
          'brand': (this.$appName || process.env.APP_NAME),
          'quantity': item.qty,
          'price': item.price
        }
      })
      this.track({ type: 'begin_checkout', event: { 'ep.items': JSON.stringify(items) } })
    },
    trackCheckoutOption () {
      this.track({ type: 'set_checkout_option', event: { 'epn.checkout_step': 2, 'ep.checkout_option': 'logistic type', 'ep.value': this.logisticType } })
      this.track({ type: 'set_checkout_option', event: { 'epn.checkout_step': 2, 'ep.checkout_option': 'store', 'ep.value': this.currentStore ? this.currentStore.name : '' } })
    },
    trackCheckoutOptionPayment () {
      this.track({ type: 'set_checkout_option', event: { 'epn.checkout_step': 3, 'ep.checkout_option': 'payment', 'ep.value': this.selectedPaymentMethod } })
    },
    trackPurchase () {
      const items = this.$store.getters.currentOrder.cart.map(item => {
        return {
          'id': item.id,
          'name': item.name,
          'brand': (this.$appName || process.env.APP_NAME),
          'quantity': item.qty,
          'price': item.price
        }
      })
      const purchaseInfo = {
        'epn.transaction_id': this.$store.getters.currentOrder.id,
        'epn.value': this.$store.getters.currentOrder.total,
        'ep.currency': 'GBP',
        'ep.items': JSON.stringify(items)
      }
      this.track({ type: 'purchase', event: purchaseInfo })
    }
  }
}
